<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.993 7.049C17.993 6.5 17.549 6.053 16.999 6.05L9.00619 6H9.00019C8.4502 6 8.00421 6.444 8.00021 6.994C7.99621 7.546 8.4412 7.997 8.99419 8L14.5521 8.035L6.29324 16.293C5.90225 16.684 5.90225 17.317 6.29324 17.707C6.48824 17.903 6.74423 18 7.00023 18C7.25622 18 7.51222 17.903 7.70721 17.707L15.995 9.419L16 15.001C16 15.553 16.448 16 17 16H17.001C17.553 16 18 15.551 18 14.999L17.993 7.049Z"
    />
  </svg>
</template>
